export const ENV_IS_PRODUCTION = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
export const ENV_IS_LOCAL_AUTH = process.env.NEXT_PUBLIC_LOCAL_AUTH?.toLocaleLowerCase() === 'true';
export const ENV_IS_MAINTENANCE_MODE =
  process.env.NEXT_PUBLIC_MAINTENANCE_MODE?.toLocaleLowerCase() === 'true';
